import { get } from "../methods";
const getDecryptedEmail = (encryptedEmail, headers = {}, baseURL) => {
  return get({
    url: "backend/auth/email/decrypt",
    headers,
    payload: {
      encrypted_email: encryptedEmail
    },
    baseURL
  }).then((res) => res?.data);
};
export {
  getDecryptedEmail
};
